/**
 * TeamBranding for a fan who has not picked a club.
 *
 * `team: null` from session.js -- no club cookie, or one naming a club App\Loyalty\FanTeam did
 * not put in the page -- is a legitimate state, and such a fan CAN still join --
 * nothing on POST /api/loyalty/join needs a team. But JoinConfirmModal's left-hand card IS the
 * team and its `team` prop is not nullable, so the join block stands the URC's own mark in. That
 * is what this site already does everywhere else it has to name a clubless fan: the same emblem
 * appears in resources/views/sections/header.blade.php and as AUTH0_GENERIC_EMBLEM_URL in
 * auth0-login.php.
 *
 * **Deliberately not pushed down into FanTeam.** `team: null` is what makes LoyaltyHero draw its
 * unbranded band on acf/loyalty-profile-header, which is the right treatment there. "What does a
 * profile hero show for a fan with no club" and "what does the confirm dialog's team card show"
 * are two questions, and only the second one needs an answer invented. See D-043.
 */

export const GENERIC_URC_TEAM = {
	// No club, so no club id. Nothing in @drewling/urc-loyalty-ui reads TeamBranding.teamId, but an empty
	// string is the honest value rather than a made-up one.
	teamId: '',
	teamName: 'United Rugby Championship',
	// $turquoise, the tile this emblem is ALWAYS shown on -- it is a white negative mark, so on
	// $deep-slate (#142837, FanTeam's own FALLBACK_COLOUR) the card reads as a dead grey box.
	primaryColor: '#00cde6',
	// No club, no club artwork. The library documents an empty string as degrading to a plain
	// colour band, which is exactly what a flat turquoise tile should be.
	patternImageUrl: '',
	crestImageUrl:
		'https://www.unitedrugby.com/wp-content/uploads/2025/09/URC_LOGO_EMBLEM_GENERIC_WHITE_NEG_RGB-1.svg',
};
